module.exports = __webpack_public_path__ + "img/ms-logo.2e0bae8e.png";